<h2 class="default-dialog-header" mat-dialog-title>
	<div fxLayout="column">
		<div fxFlex>Recent Transactions</div>
		<div fxFlex class="fs-13" fxFlex>
			Showing the {{ maxTotalTransactions }} most recent related transactions
		</div>
	</div>
	<div fxFlex fxLayoutAlign="end start">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</div>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<app-default-progress-bar *ngIf="isLoading"></app-default-progress-bar>
	<table
		[dataSource]="recentTransactionsDataTable"
		class="full-width default-border-color default-border-color m-t-1"
		mat-table
		matSort
	>
		<!-- <ng-container matColumnDef="age">
      <th mat-header-cell *matHeaderCellDef>
        <span class="fs-13 color-black">Age</span>
      </th>
      <td mat-cell *matCellDef="let element"> {{element.age}} </td>
    </ng-container> -->

		<ng-container matColumnDef="pickupDate">
			<th *matHeaderCellDef fxFlex fxLayoutAlign="center center" mat-header-cell>
				<span class="fs-13 color-black">Pickup Date</span>
			</th>
			<td *matCellDef="let element" fxFlex fxLayoutAlign="center center" mat-cell>
				{{element.pickupDate}}
			</td>
		</ng-container>

		<ng-container matColumnDef="origin">
			<th *matHeaderCellDef fxFlex fxLayoutAlign="center center" mat-header-cell>
				<span class="fs-13 color-black">Origin</span>
			</th>
			<td *matCellDef="let element" fxFlex fxLayoutAlign="center center" mat-cell>
				<div class="location px-2">{{element.origin}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="destination">
			<th *matHeaderCellDef fxFlex fxLayoutAlign="center center" mat-header-cell>
				<span class="fs-13 color-black">Destination</span>
			</th>
			<td *matCellDef="let element" fxFlex fxLayoutAlign="center center" mat-cell>
				<div class="location px-2">{{element.destination}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="trailerType">
			<th *matHeaderCellDef fxFlex fxLayoutAlign="center center" mat-header-cell>
				<span class="fs-13 color-black">Trailer Type</span>
			</th>
			<td *matCellDef="let element" fxFlex fxLayoutAlign="center center" mat-cell>
				{{element.trailerType}}
			</td>
		</ng-container>

		<ng-container matColumnDef="allInCost">
			<th *matHeaderCellDef fxFlex fxLayoutAlign="center center" mat-header-cell>
				<span class="fs-13 color-black">Total Price</span>
			</th>
			<td *matCellDef="let element" fxFlex fxLayoutAlign="center center" mat-cell>
				{{element.allInCost | currency : 'USD'}}
			</td>
		</ng-container>

		<ng-container matColumnDef="LoH">
			<th *matHeaderCellDef fxFlex="9" fxLayoutAlign="center center" mat-header-cell>
				<span
					class="fs-13 color-black"
					matTooltip="Length of Haul"
					matTooltipClass="custom-tooltip"
				>
					LoH
				</span>
			</th>
			<td *matCellDef="let element" fxFlex="9" fxLayoutAlign="center center" mat-cell>
				{{element.LoH}}
			</td>
		</ng-container>

		<ng-container matColumnDef="pricePerMile">
			<th *matHeaderCellDef fxFlex="10" fxLayoutAlign="center center" mat-header-cell>
				<span class="fs-13 color-black">Price/Mile</span>
			</th>
			<td *matCellDef="let element" fxFlex="10" fxLayoutAlign="center center" mat-cell>
				{{element.pricePerMile | currency : 'USD'}}
			</td>
		</ng-container>

		<ng-container matColumnDef="deadheadDiff">
			<th *matHeaderCellDef fxFlex fxLayoutAlign="center center" mat-header-cell>
				<span class="fs-13 color-black">Deadhead Diff</span>
			</th>
			<td *matCellDef="let element" fxFlex fxLayoutAlign="center center" mat-cell>
				{{element.deadheadDiff}}
			</td>
		</ng-container>

		<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
		<tr
			*matRowDef="let row; columns: displayedColumns;"
			[ngClass]="{'font-style-italics':row.forThisAccount}"
			mat-row
		></tr>
	</table>

	<mat-paginator
		[length]="totalTransactions"
		[pageSize]="pageSize"
		class="full-width default-border-color m-b-1"
		showFirstLastButtons
	>
	</mat-paginator>
</mat-dialog-content>
